export default {
  typeSelect: {
    marginBottom: 30,
  },
  placementText: {
    fontSize: 34,
  },
};
